import BaseLayout from './BaseLayout';
import BackgroundVideo from '../common/BackgroundVideo';

const VideoLayout = () => {
    return (
        <BaseLayout>
            <BackgroundVideo />
        </BaseLayout>
    );
};

export default VideoLayout; 